import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-crystal-charcoal via-crystal-charcoal/95 to-crystal-charcoal">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <Button variant="ghost" className="text-white/80 hover:text-white hover:bg-white/10 mb-6" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <h1 className="text-4xl font-bold text-white mb-4">Terms of Service</h1>
          <p className="text-white/60">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="glass-panel p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Agreement to Terms</h2>
            <p className="text-white/80 leading-relaxed">
              By accessing and using Crystal HACCP services, you accept and agree to be bound by the terms 
              and provision of this agreement. These Terms of Service govern your use of our food safety 
              management platform and compliance tools.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Service Description</h2>
            <p className="text-white/80 leading-relaxed mb-4">
              Crystal HACCP provides digital food safety management tools including:
            </p>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li>HACCP plan development and management</li>
              <li>Temperature monitoring and logging</li>
              <li>Incident tracking and corrective actions</li>
              <li>Compliance reporting and documentation</li>
              <li>Multi-site management capabilities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Compliance Disclaimer</h2>
            <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4 mb-4">
              <p className="text-amber-200 font-medium mb-2">⚠️ Important Legal Notice</p>
              <p className="text-white/80 leading-relaxed">
                Crystal HACCP provides <strong>guidance and tools only</strong>. Users remain fully responsible 
                for ensuring compliance with all applicable food safety regulations, laws, and industry standards. 
                Our platform does not constitute legal or regulatory advice.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">User Responsibilities</h2>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li>Maintain accurate and up-to-date account information</li>
              <li>Use the service in compliance with applicable laws and regulations</li>
              <li>Ensure proper staff training and supervision</li>
              <li>Verify all compliance requirements with local authorities</li>
              <li>Maintain appropriate backup procedures for critical data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Limitations of Liability</h2>
            <p className="text-white/80 leading-relaxed">
              Crystal HACCP shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including but not limited to loss of profits, data, use, or other 
              intangible losses resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Ownership</h2>
            <p className="text-white/80 leading-relaxed">
              You retain ownership of all data you input into our system. We provide tools to export 
              your data at any time. Upon termination, you are responsible for retrieving your data 
              within the specified retention period.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Service Availability</h2>
            <p className="text-white/80 leading-relaxed">
              While we strive for 99.9% uptime, we do not guarantee uninterrupted service availability. 
              Planned maintenance will be communicated in advance when possible.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Modification of Terms</h2>
            <p className="text-white/80 leading-relaxed">
              We reserve the right to modify these terms at any time. Users will be notified of 
              significant changes with at least 30 days notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Contact Information</h2>
            <p className="text-white/80 leading-relaxed">
              For questions about these Terms of Service, contact us at{' '}
              <a href="mailto:legal@themikanaohub.com" className="text-crystal-orange hover:text-crystal-orange-glow transition-colors">
                legal@themikanaohub.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;